import React, { useState } from 'react'
import styled from 'styled-components'
import { font, ink, line, radius, surface } from 'features/dashboard/tokens'
import EstateDocuments from 'features/bpList/Components/estates/EstateDocuments'
import EstateOwnedDocuments from 'features/bpList/Components/estates/EstateOwnedDocuments'

const VIEW_STORAGE_KEY = 'estateDocumentsView'

const readStoredView = () => {
  try {
    return localStorage.getItem(VIEW_STORAGE_KEY) === 'bp' ? 'bp' : 'owned'
  } catch (e) {
    return 'owned'
  }
}

const EstateDocumentsTab = ({ estate, buildings = [] }) => {
  const [view, setView] = useState(readStoredView)

  const selectView = nextView => {
    setView(nextView)
    try {
      localStorage.setItem(VIEW_STORAGE_KEY, nextView)
    } catch (e) {}
  }

  return (
    <Wrap>
      <Switch role='group' aria-label='Document source'>
        <SwitchButton
          type='button'
          aria-pressed={view === 'bp'}
          $active={view === 'bp'}
          onClick={() => selectView('bp')}
        >
          Building Passport documents
        </SwitchButton>
        <SwitchButton
          type='button'
          aria-pressed={view === 'owned'}
          $active={view === 'owned'}
          onClick={() => selectView('owned')}
        >
          Estate documents
        </SwitchButton>
      </Switch>

      {view === 'bp' ? (
        buildings.length === 0 ? (
          <Empty>No Building Passports in this estate yet. Add some to see their documents here.</Empty>
        ) : (
          <EstateDocuments estate={estate} buildings={buildings} />
        )
      ) : (
        <EstateOwnedDocuments estate={estate} buildings={buildings} />
      )}
    </Wrap>
  )
}

export default EstateDocumentsTab

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

const Switch = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: ${surface.wash};
  border: 1px solid ${line.base};
  border-radius: ${radius.pill};
  align-self: flex-start;

  @media (max-width: 768px) {
    align-self: stretch;
    align-items: stretch;
  }
`

const SwitchButton = styled.button`
  min-height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: ${radius.pill};
  background: ${({ $active }) => ($active ? '#33becc' : 'transparent')};
  color: ${({ $active }) => ($active ? '#ffffff' : ink.soft)};
  font-size: ${font.emphasis};
  font-weight: 600;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;
  white-space: nowrap;

  &:hover {
    background: ${({ $active }) => ($active ? '#2aa6b3' : line.base)};
  }

  @media (max-width: 768px) {
    flex: 1;
    min-width: 0;
    white-space: normal;
    padding: 6px 8px;
    font-size: 13px;
    line-height: 1.25;
  }
`

const Empty = styled.div`
  padding: 28px;
  text-align: center;
  font-size: ${font.body};
  color: ${ink.mute};
`
